import React from "react";
import Index from "pages/index";
import IndexRU from "pages/index_ru";
import IndexUA from "pages/index_ua";
import Page404 from "pages/page404";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import {createGlobalStyle} from "styled-components";
import ReferralHandler from "./components/ReferralHandler";

const GlobalStyles = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');

    html, body, #root {
        margin: 0;
        padding: 0;
        font-family: 'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        background: radial-gradient(at 0% 0%, rgba(99, 24, 118, 0.15) 0px, transparent 50%), 
                    radial-gradient(at 100% 100%, rgba(109, 50, 236, 0.15) 0px, transparent 50%), 
                    #0c0614 !important;
        background-color: #0c0614 !important;
        background-attachment: fixed !important;
        color: #ffffff !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow-x: hidden;
    }

    /* Force all Quarkly menu elements, wrappers, navs, lists, items, and containers to be completely transparent with no background */
    nav, ul, li, [class*="Menu"], [class*="menu"], .quarkly-menu, .quarkly-menu-item, nav *, [class*="Menu"] *, [class*="menu"] * {
        background: transparent !important;
        background-color: transparent !important;
    }

    /* Mobile panel wrapper background and glass blur */
    [class*="MobileSidePanel"], .mobile-side-panel, [class*="SidePanel"] {
        background: rgba(12, 6, 20, 0.95) !important;
        backdrop-filter: blur(20px) !important;
        z-index: 200000 !important;
    }

    /* Force header and its internal content wrappers to have visible overflow to prevent cutting off mobile drawer */
    .cdzv-header, section.cdzv-header, [class*="cdzv-header"], .cdzv-header > div, section.cdzv-header > div {
        overflow: visible !important;
    }

    /* Responsive visibility for desktop/mobile headers */
    .desktop-nav {
        display: flex !important;
    }
    .mobile-nav {
        display: none !important;
    }

    @media (max-width: 991px) {
        .desktop-nav {
            display: none !important;
        }
        .mobile-nav {
            display: flex !important;
            align-items: center !important;
        }
    }

    /* Make mobile menu links look spectacular and easy to tap */
    [class*="MobileSidePanel"] a.menu-link, 
    .mobile-side-panel a.menu-link,
    [class*="SidePanel"] a.menu-link {
        display: block !important;
        width: 100% !important;
        padding: 14px 20px !important;
        font-size: 18px !important;
        text-align: center !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
        box-sizing: border-box !important;
    }

    /* Mobile doc selector container styling */
    [class*="MobileSidePanel"] .doc-selector-wrapper,
    .mobile-side-panel .doc-selector-wrapper {
        margin: 10px 0 !important;
        padding: 0 !important;
        width: 100% !important;
        justify-content: center !important;
    }
    [class*="MobileSidePanel"] .doc-selector-wrapper select,
    .mobile-side-panel .doc-selector-wrapper select {
        width: 100% !important;
        text-align-last: center !important;
        padding: 12px 20px !important;
        border-radius: 10px !important;
        background-position: right 20px center !important;
    }

    /* Mobile login button full width and centered inside the mobile side drawer */
    [class*="MobileSidePanel"] a[class*="Button"],
    [class*="MobileSidePanel"] button[class*="Button"],
    .mobile-side-panel a[class*="Button"],
    .mobile-side-panel button[class*="Button"] {
        width: 100% !important;
        margin: 10px 0 !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        box-sizing: border-box !important;
    }

    /* Mobile language switcher full width with equal-sized buttons */
    [class*="MobileSidePanel"] .lang-switcher,
    .mobile-side-panel .lang-switcher {
        margin: 15px 0 0 0 !important;
        width: 100% !important;
        justify-content: center !important;
    }
    [class*="MobileSidePanel"] .lang-switcher a,
    .mobile-side-panel .lang-switcher a {
        flex: 1 !important;
        justify-content: center !important;
        text-align: center !important;
    }

    /* Hide scrollbars for menus globally and ensure smooth overflow */
    [class*="Menu"], [class*="menu"], .quarkly-menu, .quarkly-menu-item {
        overflow: visible !important;
    }
    [class*="Menu"]::-webkit-scrollbar, [class*="menu"]::-webkit-scrollbar, .quarkly-menu::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
    }

    /* Force all select dropdown elements in the header menu to be dark-glassmorphic, overriding inline styles */
    header select, nav select, [class*="Menu"] select, [aria-label*="selector"], select[aria-label*="selector"] {
        background: rgba(255, 255, 255, 0.05) !important;
        background-color: rgba(255, 255, 255, 0.05) !important;
        color: #ffffff !important;
        border: 1px solid rgba(255, 255, 255, 0.15) !important;
        border-radius: 8px !important;
        padding: 4px 8px !important;
        outline: none !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-weight: 600 !important;
        cursor: pointer !important;
    }

    header select option, nav select option, [class*="Menu"] select option, select[aria-label*="selector"] option {
        background-color: #0c0614 !important;
        color: #ffffff !important;
    }

    /* Hero Section trust badges text visibility overrides */
    .hero-trust-badge, [class*="hero-trust-badge"] {
        color: rgba(255, 255, 255, 0.8) !important;
        font-weight: 500 !important;
    }

    /* Scrollbar Styling */
    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
    ::-webkit-scrollbar-track {
        background: #0c0614;
    }
    ::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #7b2fce 0%, #5a1da8 100%);
        border-radius: 4px;
    }
    ::-webkit-scrollbar-thumb:hover {
        background: #7b2fce;
    }

    /* Glassmorphism helpers */
    .glass-card {
        background: rgba(255, 255, 255, 0.03) !important;
        backdrop-filter: blur(12px) !important;
        -webkit-backdrop-filter: blur(12px) !important;
        border: 1px solid rgba(255, 255, 255, 0.08) !important;
        border-radius: 20px !important;
        box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.3) !important;
        transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
    }

    .glass-card:hover {
        border-color: rgba(255, 255, 255, 0.15) !important;
        box-shadow: 0 12px 40px 0 rgba(109, 50, 236, 0.2) !important;
    }

    .ant-carousel .slick-dots li button {
        background: rgba(255, 255, 255, 0.3);
        opacity: 0.4;
    }

    .ant-carousel .slick-dots li.slick-active button {
        opacity: 1;
        background: #7b2fce;
        box-shadow: 0 0 10px rgba(123, 47, 206, 0.8);
    }

    /* Showcase TabButton non-active readability boost */
    div[class*="TabContainer"] button, [class*="TabContainer"] button {
        color: rgba(255, 255, 255, 0.7) !important;
    }
    div[class*="TabContainer"] button:hover {
        color: #ffffff !important;
    }
`;

export default () => (
    <Router>
        <ReferralHandler/>
        <GlobalStyles/>
        <Switch>
            <Route exact path='/' component={Index}/>
            <Route exact path='/index' component={Index}/>
            <Route exact path='/index_ua' component={IndexUA}/>
            <Route exact path='/index_ru' component={IndexRU}/>
            <Route component={Page404}/>
        </Switch>
    </Router>
);
